import useIsInIframe from 'hooks/store/useIsInIframe';
import { useFeatureFlags } from 'utils/features';

export default function useLegacyReportsEnabled() {
  const isInIframe = useIsInIframe();
  const enabled = useFeatureFlags('LEGACY_REPORTS_ACCESSIBLE') && !isInIframe;
  return enabled;
}
